import React from 'react';
import SocialLogin from 'react-social-login';

const Button = ({ children, triggerLogin, ...props }) => (    
        <div onClick={triggerLogin} {...props} style={{width:'100%'}}>
            {children}
        </div>   
)

export default SocialLogin(Button);